// extracted by mini-css-extract-plugin
export default {"groups":"groups--Y9Jr3","group":"group--dCQtt"};